/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        11/05/2022 08:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class LangSwitcherComponent {
	constructor() {
		const current_lang = $('#current-lang')
		const flag = $(current_lang)
			.find('.header__tools__item__current-lang__flag')
			.find('img')
			.attr('src')

		//On init
		$(window).on('load', () => {
			window.setTimeout(() => {
				let current_language = $('html').attr('lang').replace(/-.*/gi, '')
				if (current_language === 'auto') {
					current_language = 'fr'
				}

				//Replace current lang
				$(current_lang)
					.find('.header__tools__item__current-lang__code')
					.text(current_language)
			}, 500)
		})

		//On dropdown
		document.getElementById('current-lang').addEventListener('show.hc.dropdown', () => {
			window.setTimeout(() => {
				const list_langs = $('[data-theme="dropdown"] .glink')

				//Change Navbar Language on select
				$(list_langs).on('click', function () {
					//Replace current lang
					$(current_lang)
						.find('.header__tools__item__current-lang__code')
						.text($(this).text())
					const lang = $(current_lang)
						.find('.header__tools__item__current-lang__code')
						.text()
				})
			}, 500)
		})
	}

	static flagNameModifier(str, chr) {
		const length = str.length - 6
		const arr = str.split('')
		arr.splice(length, 2, chr)
		return arr.join('')
	}
}
